<ng-template #modalTemplate>
    <div class="fcp-modal-container" [ngClass]="'fcp-modal-container--' + size" [style]="getDynamicHeight()">
        <div class="fcp-modal-header-container">
            <div class="fcp-modal-header-sub-container">
                <fcp-icon
                    *ngIf="modalConfig.hasBackButton"
                    class="fcp-modal-header-icon"
                    [icon]="['fal', 'chevron-left']"
                    (click)="back()"
                ></fcp-icon>
                <div class="fcp-modal-header-title">{{ title }}</div>
            </div>
            <div class="fcp-modal-header-sub-container">
                <ng-content select="[fcp-modal-header]"></ng-content>
                <fcp-icon
                    *ngIf="showCloseIcon"
                    class="fcp-modal-header-icon"
                    [icon]="['fal', 'times']"
                    (click)="close()"
                ></fcp-icon>
            </div>
        </div>
        <div
            class="fcp-modal-content"
            [ngClass]="{ 'fcp-modal-content--no-padding': modalConfig.withoutContentPadding }"
        >
            <ng-content select="[fcp-modal-content]"></ng-content>
        </div>
        <ng-content select="[fcp-modal-actions]"></ng-content>
    </div>
</ng-template>
